<template>
  <div class="app-activation-tariff">
    <b-row class="carousel-row">
      <b-tabs align="center" v-bind:class="{ invisibleTabs: isInvisible }" pills card>
        <template #tabs-start><div class="tabs-start" :class="{'tabs-start-annual': hasYearTariffs === true }"><slot name="txtBeforeTabHeading"><h2>Unsere Tarife</h2></slot></div></template>
        <template #tabs-end><div class="tabs-end"><slot name="txtAfterTabHeading"></slot></div></template>
        <div class="tabs-below"><slot name="txtBelowTabHeading"></slot></div>
        <b-tab v-if="hasYearTariffs" title="Jahres-Pakete" active @click="showModal">
          <VariableModal v-if="show && hasYearTariffs"
                         :show.sync = show
                         @click:close="closeModal()">
            <template v-for="slot in possibleChildSlotsFor('AnnualModal')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </VariableModal>
          <carousel
            show-arrows
            :slides-per-page='3'
            :responsive="[
              {
                maxWidth: 960,
                slidesPerPage: 2
              },
              {
                maxWidth: 650,
                slidesPerPage: 1
              }
            ]"
            :rewind="activateLoop()"
            :center="!activateLoop()"
          >
            <div v-for="tariff in yearTariffs" :key="tariff.tariffId">
              <div  class="tariff-image-box-annual">
                <div :class="{'campain-tariff': tariff.tariffExtra.campaign === true }">
                  <div class="tariff-image"><img class="hover-toggle" :alt="tariff.name" :src="tariff.tariffExtra.img">
                  </div>
                  <div class="tarrif-image-footer">
                    <div v-b-modal.tariffDetailModal @click="setSelected(tariff)" :class="'tariff-btn-'+ tariff.tariffId">
                      Zum Tarif
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </b-tab>
        <b-tab v-if="hasSmartTariffs" title="SMART-Tarife" active>
          <carousel
            show-arrows
            :slides-per-page='4'
            :responsive="[
              {
                maxWidth: 1200,
                slidesPerPage: 3
              },
              {
                maxWidth: 960,
                slidesPerPage: 2
              },
              {
                maxWidth: 650,
                slidesPerPage: 1
              }
            ]"
            :rewind="activateLoop()"
            :center="!activateLoop()"
          >
            <div v-for="tariff in smartTariffs" :key="tariff.tariffId">
              <div class="tariff-image-box">
                <div :class="{'campain-tariff': tariff.tariffExtra.campaign === true }">
                  <div class="tariff-image"><img class="hover-togglex" :alt="tariff.name" :src="tariff.tariffExtra.img">
                  </div>
                  <div class="tarrif-image-footer">
                    <div v-b-modal.tariffDetailModal @click="setSelected(tariff)" :class="'tariff-btn-'+ tariff.tariffId">
                      Zum Tarif
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </b-tab>
        <b-tab v-if="hasComfortTariffs" title="Komfort Tarife" active>
          <carousel
            show-arrows
            :slides-per-page='4'
            :responsive="[
            {
                maxWidth: 1200,
                slidesPerPage: 3
              },
              {
                maxWidth: 960,
                slidesPerPage: 2
              },
              {
                maxWidth: 650,
                slidesPerPage: 1
              }
            ]"
            :rewind="activateLoop()"
            :center="!activateLoop()"
          >
            <div v-for="tariff in comfortTariffs" :key="tariff.tariffId">
              <div  class="tariff-image-box">
                <div :class="{'campain-tariff': tariff.tariffExtra.campaign === true }">
                  <div class="tariff-image"><img class="hover-toggle" :alt="tariff.name" :src="tariff.tariffExtra.img">
                  </div>
                  <div class="tarrif-image-footer">
                    <div v-b-modal.tariffDetailModal @click="setSelected(tariff)" :class="'tariff-btn-'+ tariff.tariffId">
                      Zum Tarif
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </b-tab>
        <b-tab v-if="hasDataTariffs" title="DATA-Tarife">
          <carousel
            show-arrows
            :slides-per-page='4'
            :responsive="[
              {
                maxWidth: 1200,
                slidesPerPage: 3
              },
              {
                maxWidth: 960,
                slidesPerPage: 2
              },
              {
                maxWidth: 650,
                slidesPerPage: 1
              }
            ]"
            :rewind="activateLoop()"
            :center="!activateLoop()"
          >
            <div v-for="tariff in dataTariffs" :key="tariff.tariffId">
              <div class="tariff-image-box">
                <div class="tariff-image"><img class="hover-toggle" :alt="tariff.name" :src="tariff.tariffExtra.img">
                </div>
                <div class="tarrif-image-footer">
                  <div v-b-modal.tariffDetailModal @click="setSelected(tariff)" :class="'tariff-btn-'+ tariff.tariffId">
                    Zum Tarif
                  </div>
                </div>
              </div>
            </div>

          </carousel>
        </b-tab>
        <b-tab v-if="hasYoungTariffs" title="Young Tarife">
          <carousel
            show-arrows
            :slides-per-page='4'
            :responsive="[
              {
                maxWidth: 1200,
                slidesPerPage: 3
              },
              {
                maxWidth: 960,
                slidesPerPage: 2
              },
              {
                maxWidth: 650,
                slidesPerPage: 1
              }
            ]"
            :rewind="activateLoop()"
            :center="!activateLoop()"
          >
            <div v-for="tariff in youngTariffs" :key="tariff.tariffId" class="tariff-image-box">
              <div>
                <div class="tariff-image"><img class="hover-toggle" :alt="tariff.name" :src="tariff.tariffExtra.img">
                </div>
                <div class="tarrif-image-footer">
                  <div v-b-modal.tariffDetailModal @click="setSelected(tariff)" :class="'tariff-btn-'+ tariff.tariffId">
                    Zum Tarif
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </b-tab>
      </b-tabs>
    </b-row>
    <TariffDetailModal :show.sync="modalShow" :extra="extra" :tariff="selectedTariff" @select-tariff="selectTariff">
      <template v-for="slot in possibleChildSlotsFor('Modal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffDetailModal>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import carousel from 'vue-ssr-carousel'
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import TariffDetailModal from './TariffDetailModal.vue'
import processSteps from '@/mixins/processSteps'
import durationUnit from '@/mixins/durationUnit'
import price from '@/mixins/price'
import joinTariffExtra from '@/helper/joinTariffExtras'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import VariableModal from '@/components/generic/VariableModal.vue'

export const stepName = 'tariff'

export default {
  name: 'ActivationTariff',
  // eslint-disable-next-line vue/no-unused-components
  components: { VariableModal, TariffDetailModal, carousel, ssrCarouselCss },
  mixins: [
    processSteps(stepName, stepName, stepName),
    slotProxy(),
    durationUnit,
    price
  ],
  data: function () {
    return {
      show: false,
      loading: false,
      selectedTariff: {},
      modalShow: false,
      productInformations: {
        productInformationList: []
      }
    }
  },
  props: {
    extra: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('activation/info', [
      'activatableTariffs'
    ]),
    ...mapGetters([
      'brand'
    ]),
    disabled: function () {
      return true
    },
    isInvisible: function () {
      let count = 0
      if (!(Object.keys(this.yearTariffs).length === 0)) count++
      if (!(Object.keys(this.dataTariffs).length === 0)) count++
      if (!(Object.keys(this.smartTariffs).length === 0)) count++
      if (!(Object.keys(this.comfortTariffs).length === 0)) count++
      if (!(Object.keys(this.youngTariffs).length === 0)) count++
      return count <= 1
    },
    hasDataTariffs: function () {
      return Object.keys(this.dataTariffs).length >= 1
    },
    hasSmartTariffs: function () {
      return Object.keys(this.smartTariffs).length >= 1
    },
    hasYearTariffs: function () {
      return Object.keys(this.yearTariffs).length >= 1
    },
    hasComfortTariffs: function () {
      return Object.keys(this.comfortTariffs).length >= 1
    },
    hasYoungTariffs: function () {
      return Object.keys(this.youngTariffs).length >= 1
    },
    fullTariffs: function () {
      return this.tariffs.map(tariff => {
        return joinTariffExtra(tariff, this.extra)
      })
    },
    tariffs: function () {
      return this.activatableTariffs.map(tariff => {
        const information = this.productInformations.productInformationList?.find(info => {
          return (info.productIdentifier === tariff.tariffId)
        })
        return {
          ...tariff,
          productInformation: information
        }
      })
    },
    dataTariffs: function () {
      return this.fullTariffs.filter(tariff => tariff.tariffExtra?.type === 'data')
    },
    smartTariffs: function () {
      return this.fullTariffs.filter(tariff => tariff.tariffExtra?.type === 'smart')
    },
    comfortTariffs: function () {
      return this.fullTariffs.filter(tariff => tariff.tariffExtra?.type === 'comfort')
    },
    youngTariffs: function () {
      return this.fullTariffs.filter(tariff => tariff.tariffExtra?.type === 'young')
    },
    yearTariffs: function () {
      return this.fullTariffs.filter(tariff => tariff.tariffExtra?.type === 'year')
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/tariff', {
      select: 'selectTariff'
    }),
    activateLoop () {
      return ((Object.keys(this.tariffs).length) >= 3)
    },
    selectTariff (tariff) {
      this.select({ tariff: tariff, nextStep: this.nextStep })
    },
    setSelected: function (selected) {
      this.modalShow = true
      this.selectedTariff = selected
    },
    closeModal () {
      this.show = false
    },
    showModal () {
      this.show = true
    }
  },
  apollo: {
    productInformations: function () {
      return wrapQuery(
        gql`query activation ($brand: String!) {
             productInformations(brand: $brand) {
                productInformationList {
                  active
                  market
                  pibName
                  productIdentifier
                  productName
                  recentVersion {
                    documentReference
                    validFrom
                    validTo
                    version
                  }
                  historicVersions {
                    documentReference
                    validFrom
                    validTo
                    version
                  }
                  variant
               }
            }
        }`, this, 'productInformations', { brand: this.brand }
      )
    }
  }
}
</script>
